import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { InternationalizationService } from '@examdojo/core/i18n';
import { ToastService } from '@examdojo/core/toast';
import { distinctUntilChanged, filter, first, map, switchMap, take, tap } from 'rxjs';
import { EMAIL_CHANGE_SUCCESS_QUERY_PARAM } from '../abstract-auth.service';

@Injectable()
export class HandleEmailVerifiedService {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly internationalizationService: InternationalizationService,
  ) {
    this.isEmailVerifiedQueryParamPresent$
      .pipe(
        filter(Boolean),
        take(1),
        switchMap(() => this.getSuccessMessage()),
        tap((message) => {
          this.toastService.success(message);
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  readonly isEmailVerifiedQueryParamPresent$ = this.route.queryParams.pipe(
    map((params) => !!params[EMAIL_CHANGE_SUCCESS_QUERY_PARAM]),
    distinctUntilChanged(),
  );

  private getSuccessMessage() {
    return this.internationalizationService.selectTranslate('examdojo.email_verified').pipe(first());
  }
}
